import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import PropTypes from 'prop-types';
import Text from '../text';
import Colors from '../colors';
import ProgressBar from '../progress-bar';
import Spacer from '../spacer';
const StyledView = styled.View`
  background-color: ${Colors.lightGray200};
  border-width: 1px;
  border-style: dashed;
  border-color: ${Colors.lightGray400};
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;
const UploadedView = styled.View`
  background-color: ${Colors.lightGray200};
  border-width: 1px;
  border-color: ${_ref => {
  let {
    error
  } = _ref;
  return error ? Colors.error400 : Colors.lightGray200;
}};
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;
const FileContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const FlexOne = styled.View`
  flex: 1;
`;
const UploadedContainer = styled.View`
  width: 100%;
`;
export default function FileUpload(props) {
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: props.onPress
  }, !props.hasFile ? /*#__PURE__*/React.createElement(StyledView, null, /*#__PURE__*/React.createElement(Text.H6, {
    color: Colors.purple400
  }, props.label)) : /*#__PURE__*/React.createElement(UploadedView, {
    error: props.error
  }, /*#__PURE__*/React.createElement(UploadedContainer, null, /*#__PURE__*/React.createElement(FileContainer, null, /*#__PURE__*/React.createElement(FlexOne, null, /*#__PURE__*/React.createElement(Text.BodyBase, {
    color: props.fileNameColor
  }, props.fileName)), /*#__PURE__*/React.createElement(Spacer, {
    size: "f12",
    width: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    onPress: props.handleAction,
    color: props.actionColor,
    weight: "medium"
  }, props.action)), props.uploading && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(ProgressBar, {
    progress: props.progress
  })))), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: props.error ? Colors.error400 : Colors.gray400
  }, props.helperText || props.error));
}
FileUpload.defaultProps = {
  label: 'Upload Photo',
  helperText: '',
  onPress: undefined,
  handleAction: undefined,
  action: '',
  hasFile: false,
  fileName: '',
  uploading: false,
  progress: 0,
  error: false,
  fileNameColor: Colors.gray600,
  actionColor: Colors.gray400
};
FileUpload.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string,
  onPress: PropTypes.func,
  handleAction: PropTypes.func,
  action: PropTypes.string,
  hasFile: PropTypes.bool,
  fileName: PropTypes.string,
  uploading: PropTypes.bool,
  progress: PropTypes.number,
  error: PropTypes.bool,
  fileNameColor: PropTypes.string,
  actionColor: PropTypes.string
};
//# sourceMappingURL=file-upload.js.map